declare const assetPath;
declare const sse;

export default async () => {

    const currentYearDisplay: HTMLElement = document.querySelector('.current-year');
    const shouldUpdate = document.querySelector('body:not(.is-editing)');

    if (currentYearDisplay && shouldUpdate) {
        currentYearDisplay.innerText = new Date().getFullYear().toString();
    }

    const sourceElement = document.querySelector('.results-count');

    const targetDiv = document.querySelector('.search-hero__title');

    if (sourceElement && targetDiv) {
        const clonedElement = sourceElement.cloneNode(true);

        targetDiv.appendChild(clonedElement);

        sourceElement.parentNode.removeChild(sourceElement);
    }


};
